export type Assets = {
  splashLogoUrl: string;
  splashLogoDarkStrokeLightFill?: string;
  homeScreenHeaderUrl: string;
  settingsIcon: string;
  splashScreenStaticUrl?: string;
  productAvatar?: string;
  doubter?: string;
  sleepioLogo?: string;
  dayLightLogo?: string;
  greenCircleCheckMark?: string;
  migrationPreview?: string;
  notificationsPreview?: string;
  turnOnNotificationWarningIcon?: string;
};

export { getAssetsForProduct } from './getAssetsForProduct';
